import { getCarbonCreditsRepository } from "../Infrastructure/CarbonCredits.repository";

export async function getCarbonCreditsLogic(params) {
  return getCarbonCreditsRepository(params);
}